import { gql } from '@apollo/client';

/**
 * 「大包差异」tab 客户展开（仅有提单号场景）。只 select bag 相关字段，并定义独立的 mawb 行类型。
 */
export const GET_WORK_PROGRESS_BAG_DIFF_CUSTOMER_BREAKDOWN = gql`
  query GetWorkProgressBagDiffCustomerBreakdown($filter: WorkProgressBagDiffCustomerBreakdownFilterInput!) {
    getWorkProgressBagDiffCustomerBreakdown(filter: $filter) {
      withMawb {
        mawb
        arrivalDate
        bagCount
        expectedBagCountSum
        inboundBagCountSum
        bagDiffSum
        bagDiffRate
      }
    }
  }
`;

export interface WorkProgressBagDiffCustomerBreakdownFilterInput {
  prePickupHubId: number;
  arrivalDateStart: string;
  arrivalDateEnd: string;
  customerId: number;
}

export interface WorkProgressBagDiffCustomerMawbSummaryRow {
  mawb: string;
  arrivalDate: string;
  bagCount: number;
  expectedBagCountSum: number;
  inboundBagCountSum: number;
  bagDiffSum: number;
  bagDiffRate: number;
}

export interface GetWorkProgressBagDiffCustomerBreakdownResponse {
  getWorkProgressBagDiffCustomerBreakdown: {
    withMawb: WorkProgressBagDiffCustomerMawbSummaryRow[];
  };
}
